import React from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

import Tooltip from '@atlaskit/tooltip';

const CutIfTooBigWrapper = styled.div<{ color: string; maxWidth: string | undefined }>`
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
  overflow: hidden;
  display: inline-block;
  ${({ color, maxWidth }) =>
    css`
      color: ${color ? color : '#000'};
      max-width: ${maxWidth ? maxWidth : '100%'};
    `};
`;
// NOTE: Only use inside of td of table with layout:fixed!
// NOTE: You can force cut at with maxWidth
export const CutIfTooBig = ({ text, tooltipText, color, maxWidth }: { text: React.ReactNode | undefined; tooltipText: string | undefined; color: string; maxWidth?: number }) => (
  <Tooltip content={tooltipText}>
    <CutIfTooBigWrapper maxWidth={maxWidth ? `${maxWidth}px` : undefined} color={color}>
      {text && text}
    </CutIfTooBigWrapper>
  </Tooltip>
);
